import React from 'react';

const Loader = ({ title, description, compact = false, fullScreen = false }) => {
    const loaderTitle = title || "Carregando dados. Por favor, aguarde.";
    const loaderDescription = description === undefined ? "Aguarde enquanto preparamos seu ambiente." : description;

    return (
        <div className={`${fullScreen ? 'evaluator-auth-loading-screen' : ''}`}>
            <div className={`evaluator-auth-loading-state ${compact ? 'is-compact' : ''}`} role="status" aria-live="polite">
                <span className="evaluator-auth-loading-icon" aria-hidden="true">
                    <i className="mdi mdi-loading"></i>
                </span>
                <span className="evaluator-auth-loading-copy">
                    <strong>{loaderTitle}</strong>
                    {loaderDescription && <small>{loaderDescription}</small>}
                </span>
            </div>
        </div>
    );
};

export default Loader;
